import { render, staticRenderFns } from "./card-num-user.vue?vue&type=template&id=2cd8d8f8&scoped=true"
import script from "./card-num-user.vue?vue&type=script&lang=js"
export * from "./card-num-user.vue?vue&type=script&lang=js"
import style0 from "./card-num-user.vue?vue&type=style&index=0&id=2cd8d8f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8d8f8",
  null
  
)

export default component.exports